<div class="weekly-grid">
  <!-- header row -->
  <div class="grid-head fixed-col"></div>
  <div
    class="grid-head"
    *ngFor="let d of days"
    [attr.data-date]="d.date.format('YYYY-MM-DD')"
  >
    {{ d.label | titlecase }}
  </div>

  <!-- driver rows -->
  <ng-container *ngFor="let row of rows; let r = index">
    <!-- left-hand side with driver info -->
    <div class="driver-col" [class.alt-row]="r % 2 === 1">
      <div class="driver-name">{{ row.displayName }}</div>

      <div class="driver-type">
        {{ getDriverTypeLabel(row.driverType) | translate }}
      </div>

      <div class="driver-meta">
        {{ formatDriverTime(row.startHour) }} –
        {{ formatDriverTime(row.endHour) }}
      </div>
    </div>

    <!-- 7 day cells -->
    <ng-container *ngFor="let day of row.tasks; let c = index">
      <div class="day-cell" [class.alt-row]="r % 2 === 1">
        <ng-container *ngFor="let t of day">
          <div
            class="task-bubble"
            [ngClass]="getStatusStyle(t)"
            (click)="openTaskDetailsModal(t, row)"
          >
            <div class="task-info">
              <div class="task-title-container">
                <!-- etiqueta principal según tipo de nodo -->
                <span class="task-title">
                  {{
                    t.nodeType === "OPERATIVE_NODE"
                      ? t.licensePlate
                      : t.nodeType === "TRANSPORT_NODE"
                      ? ("service_manager.gantt.publicTransport" | translate)
                      : ("service_manager.gantt.transferCar" | translate)
                  }}
                </span>

                <tui-icon
                  *ngIf="t.isNodeLockedForDriverAssignation"
                  icon="tuiIconLock"
                  class="task-icon"
                ></tui-icon>
                <img
                  [src]="getIcon(t.nodeId, t.verticalType)"
                  class="task-icon"
                  alt="type"
                />
              </div>

              <div class="task-title">{{ t.zoneCode }}</div>
            </div>

            <!-- fila-inferior (detalle extra) -------------------------------- -->
            <div class="task-extra">
              {{
                t.nodeType === "OPERATIVE_NODE"
                  ? t.productName + " · " + t.vehicleChassis
                  : t.nodeType === "TRANSPORT_NODE"
                  ? t.totalTime
                  : row.displayName + " · " + t.totalTime
              }}
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
